export enum Modules {
	Accounts = 1,
	AdsManager = 2,
	CampaignBuilder = 30,
	Optimize = 150,
	Pixel = 160,
	Audience = 3,
	Reports = 180,
	ProductCatalog = 161,
	CreativeBuilder = 31,
	Influencer = 90,
	Shakespeare = 91,
	BackOffice = 20,
	Miscellaneous = 130,
	Settings = 190
}
